import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { getTimes } from '../../../../../../../features/timemanager/services';

export interface TimePhaseValue {
  mode: string;
  startTime: string;
  stopTime: string;
}

@Component({
  selector: 'app-add-time-phase-modal',
  templateUrl: './add-time-phase-modal.component.html',
  styleUrls: ['./add-time-phase-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTimePhaseModalComponent implements OnInit {
  getTimes = getTimes;
  startTimeOptions: string[];
  stopTimeOptions: string[];

  selectedMode: string;
  selectedStartTime: string;
  selectedStopTime: string;

  constructor(
    public dialogRef: MatDialogRef<AddTimePhaseModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      modesOptions: string[];
    }
  ) {}

  ngOnInit(): void {
    this.startTimeOptions = this.getTimes('00:00', '24:00', '');
    this.stopTimeOptions = this.getTimes('00:00', '24:00', '');
  }

  onModeChange(value: string): void {
    this.selectedMode = value;
  }

  onStartTimeChange(value: string): void {
    this.selectedStartTime = value;
    this.stopTimeOptions = this.getTimes(this.selectedStartTime, '24:00', '');
  }

  onStopTimeChange(value: string): void {
    this.selectedStopTime = value;
    this.startTimeOptions = this.getTimes('00:00', this.selectedStopTime, '');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    const value: TimePhaseValue = {
      mode: this.selectedMode,
      startTime: this.selectedStartTime,
      stopTime: this.selectedStopTime,
    };

    this.dialogRef.close(value);
  }

  isAddButtonDisabled(): boolean {
    if (this.data.modesOptions.length) {
      return !(this.selectedMode && this.selectedStartTime && this.selectedStopTime);
    } else {
      return !(this.selectedStartTime && this.selectedStopTime);
    }
  }
}
